import { t } from 'i18next';
import { TIllustration } from '../../Illustration';
import { useGameStore } from '../../../stores';
import { formatNumberWithCommas } from '../../../helpers/formatting';

export const useSlidesData = () => {
  const { competitionModeStatus, generalModeStatus, trainingModeStatus } =
    useGameStore();

  return [
    {
      id: 'competition',
      title: t('game.competition_mode_title'),
      text: t('game.competition_mode_text'),
      bgImg: 'CompetitionMode' as TIllustration,
      attempts: competitionModeStatus?.attempts,
      score: formatNumberWithCommas(competitionModeStatus?.score),
      totalAttempts: competitionModeStatus?.totalAttempts,
    },
    {
      id: 'general',
      title: t('game.general_mode_title'),
      text: t('game.general_mode_text'),
      bgImg: 'GeneralMode' as TIllustration,
      attempts: generalModeStatus?.attempts,
      score: formatNumberWithCommas(generalModeStatus?.score),
      totalAttempts: generalModeStatus?.totalAttempts,
    },
    {
      id: 'training',
      title: t('game.training_mode_title'),
      text: t('game.training_mode_text'),
      attempts: trainingModeStatus?.attempts,
      bgImg: 'TrainingMode' as TIllustration,
      totalAttempts: trainingModeStatus?.totalAttempts,
    },
  ];
};
